import { useState } from "react";
import { AxiosRequestConfig } from "axios";

import { useApi } from "../useApi/useApi";
import { Upload, uploadToFormData } from "../../models/Upload";

/**
 * Upload Progress
 */
export type Progress = {
  complete: number;
  total: number;
};

/**
 * Upload hook to post data to backend
 */
export const usePostUpload = () => {
  const [progress, setProgress] = useState<Progress>({ complete: 0, total: 0 });
  const { state, updateRequest } = useApi<Upload>();

  const resetProgress = () => {
    setProgress({ complete: 0, total: 0 });
  }

  const post = (data: Upload) => {
    resetProgress();
    const config: AxiosRequestConfig = {
      url: "/api/upload",
      method: "post",
      data: uploadToFormData(data),
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (progressEvent) => {
        setProgress({
          complete: progressEvent.loaded || 0,
          total: progressEvent.total || 0,
        });
      },
    };
    updateRequest(config);
  };

  return { postUpload: state, postProgress: progress, post };
};
